import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import injectTapEventPlugin from 'react-tap-event-plugin';
import Config from '@blockcatio/tabby-library/lib/services/Config';
import getStaticWeb3Engine from '@blockcatio/tabby-library/lib/services/staticWeb3Engine';
import Web3Eth from 'web3-eth';

import AppContainer from './AppContainer';
import createStore from './store';
import migrations from './migrations';
import buildServices from './services';
import { NETWORK_NAMES } from './constants';
import defaults from './config/defaults.json';
import localDeployment from './config/local-deployment.json';
import './polyfills';

// Needed for onTouchTap
// http://stackoverflow.com/a/34015469/988941
injectTapEventPlugin();

const config = new Config(defaults, window.deploymentConfig || localDeployment);
const staticWeb3Eth = getStaticWeb3Engine(config.get('NETWORK_RPC_URL'));
const services = buildServices(config, staticWeb3Eth, Web3Eth.givenProvider);
const store = createStore(services, config);
const latestContract = config.get('CONTRACTS').TabbyPay.pop();

const listedTokens = (() => {
  try {
    if (config.get('CONTRACT_NETWORK_ID') === 1) {
      // eslint-disable-next-line global-require, import/no-unresolved
      return require('./tokenLists/mainNet.json');
    }
    if (config.get('CONTRACT_NETWORK_ID') === 42) {
      // eslint-disable-next-line global-require, import/no-unresolved
      return require('./tokenLists/kovan.json');
    }
  } catch (error) {
    // do nothing
  }
  return {};
})();

const gasLimits = {
  createPaymentGasLimitEthByCat: latestContract.createPaymentGasLimitEthByCat,
  createPaymentGasLimitTokenByCat: latestContract.createPaymentGasLimitTokenByCat,
  createPaymentGasLimitEthByEth: latestContract.createPaymentGasLimitEthByEth,
  createPaymentGasLimitTokenByEth: latestContract.createPaymentGasLimitTokenByEth,
  acceptPaymentGasLimit: latestContract.acceptPaymentGasLimit,
};

const networkName = NETWORK_NAMES[config.get('CONTRACT_NETWORK_ID')];
const app = (
  <Provider store={store}>
    <AppContainer
      envName={config.get('ENV_NAME')}
      networkName={networkName}
      payContractAddress={latestContract.address}
      catPaymentContractAddress={config.get('CONTRACTS').CatPaymentCollector.address}
      catTokenContractAddress={config.get('CONTRACTS').CatToken.address}
      tokenList={listedTokens}
      gasLimits={gasLimits}
      onError={services.errorReporter}
      givenProvider={Web3Eth.givenProvider}
    />
  </Provider>
);

window.store = store;
window.services = services;

try {
  services.migrator(services.storage, migrations);
} catch (error) {
  services.errorReporter(error, undefined, true);
  services.storage.clear();
  services.migrator(services.storage, migrations);
}
ReactDOM.render(app, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js